import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAtom } from 'jotai';
import includes from 'lodash/includes';
import { setSelectedMetrics, setAppliedSort } from '@store/metricLens/base/actions';
import { supportedMetricsSelector } from '@store/common/selectors';
import { selectedMetricsSelector, appliedSortSelector } from '@store/metricLens/base/selectors';
import { useCurrentLimitation } from '@src/hooks/useCurrentLimitation';
import MetricSelectorPopup from '@components/common/MetricSelectorPopup';
import { track } from '@utils';
import { CLICK_ML_METRICS_CHANGE } from '@src/utils/sensor/track';
import { DropdownWrapper } from '../styled';
import useGlobalExcludeMetricCategories from '@src/hooks/metrics/useGlobalExcludeMetricCategories';
import useSupportedMetrics from '@src/hooks/metrics/useSupportedMetrics';
import { currentKpiIdAtom } from '@src/atoms/panels';

const MetricsDropDown = () => {
  const dispatch = useDispatch();
  const selectedMetrics = useSelector(selectedMetricsSelector);
  const appliedSort = useSelector(appliedSortSelector);
  const limitation = useCurrentLimitation();
  const supportedMetrics = useSelector(supportedMetricsSelector);
  const excludeCategories = useGlobalExcludeMetricCategories([]);
  const [currentKpiId, setCurrentKpiId] = useAtom(currentKpiIdAtom);

  const metrics = useSupportedMetrics({
    excludeCategories,
    allMetrics: supportedMetrics,
    limitation,
  });

  const onPopupApply = (data, kpiChanged) => {
    // kpiChanged is not used as setSelectedMetrics is called every time
    // saga listens to it and fetches data
    // axios cache is cleared if kpi changed
    if (!includes(data, appliedSort.metric) && data.length > 0) {
      dispatch(
        setAppliedSort({
          filter: 0,
          metric: data[0],
          order: 'desc',
        }),
      );
    }
    dispatch(setSelectedMetrics(data));
    track({ event: CLICK_ML_METRICS_CHANGE, data: { metrics: data } });
  };

  return (
    <DropdownWrapper>
      <MetricSelectorPopup
        supportedMetrics={metrics}
        selectedMetrics={selectedMetrics}
        lockedMetrics={[]}
        config={limitation?.metrics?.config}
        onApply={onPopupApply}
        currentKpiId={currentKpiId}
        onKpiChange={setCurrentKpiId}
      />
    </DropdownWrapper>
  );
};

export default MetricsDropDown;
